import { HierarchyNode } from '®shared/hierarchy';
import { License, ListAccess, Period } from '®shared/tenant';
import { UserRecord } from '®shared/user';

import { ReadingListDetails } from './reading-list-details';

export enum ListPublishingState {
  NO_PUBLISH_ACTIONED = 'No publish actioned',
  PUBLISH_ACTIONED = 'Publish actioned',
  PUBLISH_ACTION_PERSISTED = 'Publish action persisted',
  PUBLISH_ACTION_SUCCEEDED = 'Publish action succeeded',
}

export interface EditableList {
  id: string;
  type: string;
  title: string;
  description?: string;
  license?: License | null;
  period?: Period | null;
  listAccess?: ListAccess | null;
  hasUnpublishedChanges?: boolean;
  hasEverBeenPublished?: boolean;
  publishingState?: ListPublishingState;
  nodes: HierarchyNode[];
  totalStudentNumbers?: number;
  activeReviewUrl?: string;
  owners?: UserRecord[];
  internalNote?: string;
}

export function convertReadingListToEditableList(
  readingListDetails: ReadingListDetails,
): EditableList {
  const {
    id,
    type,
    title,
    description,
    license,
    period,
    hasUnpublishedChanges,
    isPublishing,
    last_published,
    list_access = null,
    nodes,
    totalStudentNumbers,
    activeReviewUrl,
    owners,
    internal_note,
  } = readingListDetails;

  return {
    id,
    type,
    title,
    description,
    license,
    period,
    hasUnpublishedChanges,
    listAccess: list_access,
    hasEverBeenPublished: last_published ? true : false,
    publishingState: isPublishing
      ? ListPublishingState.PUBLISH_ACTION_PERSISTED
      : ListPublishingState.NO_PUBLISH_ACTIONED,
    nodes,
    totalStudentNumbers,
    activeReviewUrl,
    owners,
    internalNote: internal_note,
  };
}
